/* global JitsiMeetJS */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disconnected } from './Redux/Reducers/Connection';
import LandingPage from "./pages/LandingPage";
import ConferenceWrapper from "./pages/ConferenceWrapper";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ToastContainer } from 'react-toastify';
import LimiterNode from "audio-limiter";
import NoInternetConnectionWrapper from "./components/NoInternetConnectionWrapper";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';


const AudioContext = window.AudioContext || window.webkitAudioContext;

export default function App() {
	const dispatch = useDispatch();
	const { themeMode, isEventJoined, videoInputDeviceId, audioInputDeviceId, audioOutputDeviceId } = useSelector(state => state.connection);
	const [connection, setConnection] = useState(null);
	window.APP.audioContext = new AudioContext();
	window.APP.audioContextDestination = window.APP.audioContext.createMediaStreamDestination();
	window.APP.limiter = new LimiterNode(window.APP.audioContext, { time: 0.005 });

	const unloadEventListener = () => {
		dispatch(disconnected());
	}

	const getStarted = () => {
		let room = "meet-room-1"

		const options = {
			hosts: {
				domain: process.env.REACT_APP_JITSI_URL,
				muc: `conference.${process.env.REACT_APP_JITSI_URL}`
			},
			serviceUrl: `https://${process.env.REACT_APP_JITSI_URL}/http-bind?room=${room}`,
			deploymentInfo: {},
			// bosh: `https://media.rsi-now.com/http-bind?room=${room}`,
		};
		const initOptions = {
			// disableSimulcast : false,
			disableAP: true,
			disableAEC: true,
			disableNS: true,
			disableAGC: true,
			disableHPF: true,
			stereo: true,
			disableLipSync: true,
			maxaveragebitrate: 510000,
			enableTcc: true
		};
		JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
		JitsiMeetJS.init(initOptions);

		let con = new JitsiMeetJS.JitsiConnection(null, null, options);
		setConnection(con);
		con.connect();

		window.addEventListener("beforeunload", unloadEventListener);
	}

	useEffect(() => {
		getStarted();

		return () => {
			dispatch(disconnected());
			window.removeEventListener('beforeunload', unloadEventListener);
		}
	}, []);





	return (
		<div className={`App ${themeMode}`}>
			<ToastContainer className="toast-position"
				position="top-center" />
			<NoInternetConnectionWrapper setOnline={(flag) => {
				if (flag) {
					window.location.reload();
				}
			}}>
				<Header />
				{!isEventJoined &&
					<LandingPage />
				}
				{isEventJoined &&
					<ConferenceWrapper
						connection={connection}
						videoInputDeviceId={videoInputDeviceId}
						audioInputDeviceId={audioInputDeviceId}
						audioOutputDeviceId={audioOutputDeviceId}
					/>
				}
				<Footer />
			</NoInternetConnectionWrapper>
		</div>
	);
}
